import { call } from 'redux-saga/effects';
import { initializePendo } from '../lib';

import { combineAllWatchers, createWatcherSaga, SagaYieldType } from '@sonar-software/xuder';
import { PendoActionType, PendoInitializeAction } from './actions';

/* eslint-disable */
export function* initializePendoSaga(action: PendoInitializeAction) {
	/* eslint-enable */
	const { account, visitor } = action;

	yield call(initializePendo, account, visitor);
}

export const watchInitializePendoSaga = createWatcherSaga([
	{
		action: PendoActionType.RequestInitialize,
		actionHandler: initializePendoSaga,
		type: SagaYieldType.Every
	}
]);

export const pendoWatchers = combineAllWatchers([
	watchInitializePendoSaga
]);
